export default {
    install(app, { router }) {
      app.config.globalProperties.$getRoute = () => router.currentRoute.value;
    },
  };